<template lang="html">
  <div :style="{ marginBottom: isFirst ? 0 : '80px' }">
    <v-row>
      <v-col
        v-for="idx in isFirst ? (!isList ? 12 : 6) : !isList ? 6 : 2"
        :key="idx"
        :cols="isList ? 12 : 6"
        :xs="isList ? 12 : 4"
        :md="isList ? 6 : 3"
        :lg="isList ? 6 : 2"
      >
        <div :class="[`item-product-skeleton p-relative`, { 'list-mode': isList }]">
          <div class="item-product-skeleton-wrap">
            <div class="item-product-skeleton-avatar">
              <div class="item-product-skeleton-image">
                <v-skeleton-loader v-bind="$attrs" type="image" />
              </div>
            </div>
            <div class="item-product-skeleton-content">
              <div>
                <div class="item-product-skeleton-price mb-1">
                  <div>
                    <v-skeleton-loader v-bind="$attrs" type="list-item" />
                  </div>
                  <div>
                    <v-skeleton-loader v-bind="$attrs" type="list-item" />
                  </div>
                </div>
                <div class="item-product-skeleton-title mb-3">
                  <v-skeleton-loader v-bind="$attrs" type="list-item" />
                </div>
              </div>
              <div class="item-product-skeleton-action">
                <v-skeleton-loader v-bind="$attrs" type="list-item" />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'CustomSkeleton',
  props: {
    isList: {
      default: false,
      type: Boolean
    },
    isFirst: {
      default: true,
      type: Boolean
    }
  }
}
</script>
<style>
.item-product-skeleton {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.0392156863) !important;
  border: 0.5px solid #eeeeee !important;
  border-radius: 5px !important;
  height: 100%;
}
.item-product-skeleton-wrap {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: inherit;
  height: 100%;
  display: flex;
}
.item-product-skeleton.list-mode > .item-product-skeleton-wrap {
  flex-direction: row;
  border-top-left-radius: inherit;
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: inherit;
}
.item-product-skeleton.list-mode .item-product-skeleton-avatar {
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: inherit;
  overflow: hidden;
}
.item-product-skeleton-image {
  margin-right: 0;
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding: 95% 0 0 0;
}
.item-product-skeleton.list-mode .item-product-skeleton-image {
  width: 164px;
  height: 148px;
}
.item-product-skeleton-image .v-skeleton-loader {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto auto;
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: inherit;
  overflow: hidden;
}
.item-product-skeleton-image .v-skeleton-loader > div {
  height: 100%;
}
.item-product-skeleton-content {
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: space-between;
}
.item-product-skeleton-price {
  display: flex;
  gap: 4px;
}
.item-product-skeleton-price > div {
  flex: 1 1 auto;
}
.item-product-skeleton-price .v-skeleton-loader > div,
.item-product-skeleton-title .v-skeleton-loader > div,
.item-product-skeleton-action .v-skeleton-loader > div {
  height: auto;
  padding: 0px;
}
.item-product-skeleton-price .v-skeleton-loader > div > .v-skeleton-loader__text {
  height: 19px;
}
.item-product-skeleton-title .v-skeleton-loader > div > .v-skeleton-loader__text {
  height: 38px;
}
.item-product-skeleton-action .v-skeleton-loader > div > .v-skeleton-loader__text {
  height: 16px;
}
</style>
